import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { z } from "zod";
import { getClientsheetDownloadUrlApiV1ClientsheetDownloadUrlGet } from "@/client";
import { Button } from "@/components/ui/button";
import { cn, dateSchema } from "@/lib/utils";

export function DownloadClientsheetButton({
  date,
  text,
  className,
}: {
  date: z.infer<typeof dateSchema>;
  text?: string;
  className?: string;
}) {
  const { t } = useTranslation();
  const { mutateAsync: downloadClientsheet, isPending } = useMutation({
    mutationFn: getClientsheetDownloadUrlApiV1ClientsheetDownloadUrlGet,
  });

  const validatedDate = dateSchema.parse(date);

  return (
    <Button
      disabled={isPending}
      className={cn(className)}
      onClick={async () => {
        try {
          const presignedUrl = await downloadClientsheet({
            date: validatedDate,
          });

          const link = document.createElement("a");
          link.href = presignedUrl;
          link.setAttribute("download", `clientsheet-${validatedDate}.pdf`);

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);
        } catch (error) {
          console.error("Error downloading clientsheet:", error);
        }
      }}
    >
      {isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : text ? t(text) : t("Download")}
    </Button>
  );
}
